export const skipInterceptionUrls = ['smarty']
